import React, { useState } from "react";
import "./styles/contact.css";

const Contact = () => {
  const handleWhatsApp = () => {
    const phoneNumber = "919926540204";
    const message = encodeURIComponent("Hello, I have an inquiry.");
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, "_blank");
  };
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, message } = formData;

    const whatsappMessage = `Name: ${name}%0AEmail: ${email}%0AMessage: ${message}`;
    const url = `https://wa.me/919669143999?text=${whatsappMessage}`;
    window.open(url, "_blank");
  };

  return (
    <div className="contact-container">
      <h1 className="contact-title">Contact Us</h1>
      <form className="contact-form" onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder="Your Name"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Your Email"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <textarea
          name="message"
          rows="5"
          placeholder="Your Message"
          value={formData.message}
          onChange={handleChange}
          required
        ></textarea>
        <button type="submit">Send Message on WhatsApp</button>
      </form>

      <div className="contact-links">
        <h2>Reach Out to Us</h2>
        <p>
          📞 Phone: <a href="tel:+919926540204">+91 9926540204</a>
        </p>
        <p>
          📞 Phone: <a href="tel:+919826073169">+91 9826073169</a>
        </p>
        <p>
          📞 Phone: <a href="tel:+917389763300">+91 7389763300</a>
        </p>
        <p>
          📧 Email:{" "}
          <a href="mailto:newganeshbakers5@gmail.com">
            newganeshbakers5@gmail.com
          </a>
        </p>
        <p>
          📸 Instagram:{" "}
          <a
            href="https://www.instagram.com/_new_ganesh_bakers/?hl=en"
            target="_blank"
          >
            @newganeshbakers
          </a>
        </p>
        <p>
          💬 WhatsApp:{" "}
          <button onClick={handleWhatsApp}>Message on WhatsApp</button>
        </p>
      </div>
    </div>
  );
};

export default Contact;
